import React from "react";
import { appHelpers } from "../../_helpers";

const InvoiceTable = ({ invoiceTableData }) => {
  return (
    <div className="invoice-table">
      <p className="invoice-table-header">Items</p>
      <table className="w-full">
        <thead className="table-head">
          <tr className="">
            <th>S/No.</th>
            <th className="border-x-[1.32px] text-[8px] font-medium border-light-ash p-2 text-left">
              Item Description
            </th>
            <th>Qty/Weight</th>
            <th>Unit Price</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody className="table-body">
          {invoiceTableData === null ? (
            <tr className="empty-row">
              <td className="number border-x-[1.32px] border-light-ash font-medium p-2 pb-8 text-[#929292] text-center text-[8px]">
                1.
              </td>
              <td className="border-x-[1.32px] border-light-ash font-medium p-2 pb-8 text-[8px]">
                -------
              </td>
              <td className="border-x-[1.32px] border-light-ash font-medium p-2 pb-8 text-[8px] text-center">
                -------
              </td>
              <td className="border-x-[1.32px] border-light-ash font-medium p-2 pb-8 text-[8px] text-center">
                -------
              </td>
              <td className="border-x-[1.32px] border-light-ash font-medium p-2 pb-8 text-[8px] text-center">
                -------
              </td>
            </tr>
          ) : (
            <tr className="table-row">
              <td
                className={`border-x-[1.32px] border-light-ash font-medium p-2 text-[#929292] text-center text-[8px] bottom-8`}
              >
                1.
              </td>
              <td
                className={`border-x-[1.32px] border-light-ash font-medium p-2 text-[8px] bottom-8`}
              >
                {invoiceTableData?.description || "-------"}
              </td>
              <td className={`bottom-8`}>
                {invoiceTableData?.quantity || "-------"}
              </td>
              <td className={`bottom-8`}>
                {invoiceTableData?.amount
                  ? "₦" + appHelpers.numberWithCommasOnly(invoiceTableData?.amount, 2)
                  : "-------"}
              </td>
              <td className={`bottom-8`}>
                {invoiceTableData?.amount
                  ? "₦" + appHelpers.numberWithCommasOnly(
                      invoiceTableData?.quantity
                        ? invoiceTableData?.amount * invoiceTableData?.quantity
                        : invoiceTableData?.amount,
                      2
                    )
                  : "-------"}
              </td>
            </tr>
          )}
        </tbody>
        <tfoot className="table-foot">
          <tr className="bg-[#F5F5F5]">
            <td></td>
            <td></td>
            <td></td>
            <td className="amount total">Total:</td>
            <td className="amount">
              {!invoiceTableData?.amount
                ? "-------"
                : "₦" + appHelpers.numberWithCommasOnly(
                    invoiceTableData?.quantity
                      ? invoiceTableData?.amount * invoiceTableData?.quantity
                      : invoiceTableData?.amount,

                    2
                  )}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default InvoiceTable;
